// vendorsVerify.js
import apiClient from "./axios.config";

const ownersVerify = {
  verify: async (ownerGuid) => {
    console.log(ownerGuid);
    try {
      const response = await apiClient.post(
        `/owner/email-verification?ownerGuid=${ownerGuid}`
      );

      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },
};

export default ownersVerify;
